import { createReducer } from '@reduxjs/toolkit';
import { sendFiatBackRequest } from '../actions/sendFiatBack';

const initialState = {
  loading: true,
  data: {},
};
export default createReducer(initialState, (builder) => {
  builder.addCase(sendFiatBackRequest.fulfilled, () => {
  });
});
